console.log('env', process.env);

export const config = {
  baseModelPath: process.env.REACT_APP_MODEL_BASE_PATH || '/models',
  roomSize: [10, 10, 5] as XYZ,
  roomPadding: 0.1,
  carPadding: 0.5,
}

console.log('config', config);

export type Config = typeof config;